import React from 'react'
import {translate} from 'react-i18next'
import styled from 'styled-components'

import theme from 'theme'
import Link from 'components/Link'
import ButtonView from 'components/button/ButtonView'
import DefaultButtonText from 'components/button/ButtonText'
import ButtonSpinner from 'components/button/ButtonSpinnerDot'

const getFontBoldFamily = props => props.theme.font.boldFamily

const StyledButtonView = styled(ButtonView)`
  font-family: ${getFontBoldFamily};
`

const StyledButtonText = styled(DefaultButtonText)`
  font-family: inherit;
  position: relative;
`

const LinkWrapper = styled.div`
  margin-top: ${props => props.marginTop || '40px'};
`

const LinkWithButton = ({to, buttonTheme = theme.buttons.primary, text, marginTop, onClick, loading}) => (
  <LinkWrapper marginTop={marginTop}>
    <Link to={to} rel="noopener noreferrer" onClick={onClick} loading={loading} external>
      <StyledButtonView full {...buttonTheme}>
        {loading ? <ButtonSpinner /> : <StyledButtonText styles={{}}>{text}</StyledButtonText>}
      </StyledButtonView>
    </Link>
  </LinkWrapper>
)

export default translate()(LinkWithButton)
